import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-foi',
  templateUrl: './foi.component.html',
  styleUrls: ['./foi.component.css']
})
export class FoiComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
